import { render, staticRenderFns } from "./NewsBlogList.vue?vue&type=template&id=9faac6ce"
import script from "./NewsBlogList.vue?vue&type=script&lang=js"
export * from "./NewsBlogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports